import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      position: "relative",
      zIndex: 0,
    },
    playerWrapper: {
      position: "relative",
      paddingTop: "56.25%",
      zIndex: -500,
    },
    player: {
      position: "absolute",
      zIndex: -1500,
      top: 0,
      left: 0,
      "& video": {
        objectFit: "cover",
      },
    },
    overlay: {
      background: "linear-gradient(180deg,rgba(0,0,0,0) 0,#000 100%)",
      width: "100%",
      height: "50%",
      position: "absolute",
      zIndex: 100,
      bottom: 0,
      left: 0,
      opacity: 0.5,
      pointerEvents: "none",
    },
    imageName: {
      position: "absolute",
      zIndex: 100,
      left: 10,
      bottom: 0,
      width: "auto",
      height: "35%",
      pointerEvents: "none",
    },
    poster: {
      zIndex: "100",
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
    },
    duration: {
      position: "absolute",
      zIndex: 100,
      fontSize: 12,
      color: "#fff",
      right: 10,
      bottom: 10,
      pointerEvents: "none",
      "&.static": {
        right: 15,
        bottom: 18,
        fontSize: 18,
      },
      [theme.breakpoints.up("mobile")]: {
        right: 20,
        bottom: 15,
        "&.static": {
          bottom: 13,
        },
      },
      [theme.breakpoints.up("tablet")]: {
        right: 40,
        bottom: 30,
        fontSize: 18,
        "&.static": {
          right: 9,
          bottom: 10,
          fontSize: 15,
        },
      },
    },
    clipSkeleton: {
      width: "inherit",
      height: "inherit",
    },
  }),
  { name: "StarringYouClip" },
);
